module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-8x9-0e75e2f14b56f09ab5a3be88c5b7ac7f.jpg";